import React from 'react';
import classNames from 'classnames';
import {injectIntl, intlShape, FormattedRelative} from 'react-intl';

import {convertCipIdeaStateName, INITIATIVE_TYPE, CIP_TYPE, convertInitiativeStateName} from '../../constants';

class IdeaStateLabel extends React.Component {

  render() {
    const {intl} = this.props;
    const t = (message, data = {}) => {
        if(!message) return '';
        return intl.formatMessage({id : message}, data);
    };
    const { state } = this.props;
    const {type} = this.props;
    var classes = {
            'label' : true,
            'label-primary' : state == 1,
            'label-warning' : state == 2 || state == 3 || state == 6, 
            'label-success' : state == 4, 
            'label-danger' : state == 5
    } ;   
    if(type == CIP_TYPE){
        classes = {
            'label' : true,
            'label-primary' : state == 0,
            'label-warning' : state == 1, 
            'label-success' : state == 2, 
            'label-danger' : state == 3
        }; 
    }
    return (        
        <span className={classNames(classes)}>{t(type == CIP_TYPE ? convertCipIdeaStateName(state) : convertInitiativeStateName(state))}</span>
    );
  }
}

IdeaStateLabel.displayName = 'CipStatusLabel';
IdeaStateLabel.propTypes = {};
IdeaStateLabel.defaultProps = {};

export default injectIntl(IdeaStateLabel);



// WEBPACK FOOTER //
// ./components/Shared/IdeaStateLabel.js